import React from 'react';

function CardCheckIcon({ w, h, strokeColor, strokeWidth, style }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={w} height={h} viewBox="0 0 14 12" style={style}>
      <polyline
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        points="1 6.419 5.4 11 13 1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

CardCheckIcon.defaultProps = {
  w: 14,
  h: 12,
  strokeColor: '#544E3B',
  strokeWith: 1.5,
};

module.exports = CardCheckIcon;
